import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import HeroSection from "./components/HeroSection";
import ImpactBanner from "./components/ImpactBanner";
import MissionSection from "./components/MissionSection";
import EventsSection from "./components/EventsSection";
import NewsSection from "./components/NewsSection";
import CTASection from "./components/CTASection";
import { useSiteSettings, type ContactSettings } from "@/lib/siteSettings";

const siteUrl = import.meta.env.VITE_SITE_URL || "";

const buildHomeSchema = (contact: ContactSettings) => [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "TAIAA 台灣 AI 應用推廣協會",
    url: siteUrl || undefined,
    description:
      "TAIAA 台灣 AI 應用推廣協會致力於推動 AI 技術在企業與社會中的實際應用、促進產官學研合作、建立可信任且負責任的 AI 應用生態系。",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "TAIAA 台灣 AI 應用推廣協會",
    alternateName: "Taiwan AI Application Association",
    url: siteUrl || undefined,
    logo: siteUrl ? `${siteUrl}/vite.svg` : undefined,
    email: contact.email,
    telephone: contact.phone || undefined,
    address: {
      "@type": "PostalAddress",
      streetAddress: contact.address,
      addressCountry: "TW",
    },
    description:
      "TAIAA 台灣 AI 應用推廣協會致力於推動 AI 技術在企業與社會中的實際應用、促進產官學研合作、建立可信任且負責任的 AI 應用生態系。",
  },
];

export default function Home() {
  const { settings } = useSiteSettings();
  const homeSchema = buildHomeSchema(settings.contact);
  return (
    <main>
      <SEO
        title="TAIAA｜台灣 AI 應用推廣協會 — 推動 AI 應用落地，連結台灣產業未來"
        description="TAIAA 台灣 AI 應用推廣協會致力於推動 AI 技術在企業與社會中的實際應用、促進產官學研合作、建立可信任且負責任的 AI 應用生態系。"
        keywords="TAIAA,台灣 AI 應用推廣協會,AI 應用,人工智慧,產業交流,人才培育"
        schema={homeSchema}
      />
      <HeroSection />
      <ImpactBanner />
      <MissionSection />
      <NewsSection />
      <EventsSection />
      <CTASection />
    </main>
  );
}